/* eslint-disable */
export default {
	init() { 
	// JavaScript to be fired on all pages

		var $reviews = (function() {

			var setMinHeights = function() {
				$('.review-tile').each(function() {
					var container = $(this).closest('.ha-reviews').find('.ha-reviews__slider');

					$(this).css('min-height', container.height() + 'px')
				});
			},

			init = function() {
				setMinHeights();
				$(window).on('resize', setMinHeights);
				var $sliders = $('.ha-reviews__slider');
				$sliders.each(function() {
					$(this).on('init', setMinHeights)
				});
			};

			return {init: init};

		})();

		$reviews.init();	

		$('.nav-main .menu-item-has-children > a').on('click', function(e) {
			e.preventDefault();
			$(this).closest('li').toggleClass('menu-item--open');
		});

		// $(function(){

		// 	var $caseStudies = (function() {

		// 		var $select = $('[data-category]'),
		// 			$cases = $('[data-slick-index]'),

		// 		init = function() {
		// 			$select.on('click', function() {
		// 				var $selected = $(this).data('filter-cases');
		// 				console.log($selected);
		// 				if( $.trim($selected) == '' ) {
		// 					$cases.show();
						
		// 				} else {
		// 					$cases.hide();
		// 					$cases.each(function() {
		// 						var $types = $(this).data('slick-index');
		// 						if( $types.indexOf($selected) !== -1 ) {
		// 							$(this).show();
									
		// 						}
		// 					});
		// 				}
		// 			});
		// 		};

		// 		return {init: init};

		// 	})();

		// 	$caseStudies.init();

		// });
	
		var $fixed = (function() {

			var $elems = $('[data-fixed]'),
				$header = $('.header-main'),
				$nav = $('.header-main__nav'),
				$footerCta = $('.footer-cta'),
				$footer = $('.footer-main'),
				$adminBar = $('#wpadminbar'),

			calculateTop = function($scroll) {
				var $headerHeight = $header.length > 0 ? $header.outerHeight() : 0;
				var $navHeight = $nav.length > 0 && $nav.is(':visible') ? $nav.outerHeight() : 0;
				var $adminBarHeight = $adminBar.length > 0 && $adminBar.is(':visible') ? $adminBar.outerHeight() : 0;
				var $height = $headerHeight + $navHeight + $adminBarHeight;
				var $top = $height - Math.min(Math.max($scroll, 0), $height);
				return Math.min($height, $top);
			},

			calculateStop = function() {
				var $offset = $footerCta.length > 0 ? $footerCta.offset().top : $footer.offset().top;
				return $offset - $(window).height();

			},

			setTop = function() {
				var $scroll = $(window).scrollTop();
				var $top = calculateTop($scroll);
				var $stop = calculateStop();
				$elems.each(function() {
					$(this).css('margin-top', $top + 'px');
					$(this).css('margin-bottom', -$top + 'px');
					if( $scroll > $stop ) {
						$(this).css('margin-bottom', $scroll - $stop + 'px');
						$(this).css('margin-top', $stop - $scroll + 'px');
					} else {
						// $(this).css('bottom', 0);
					}
				});
			},

			init = function() {
				$(window).load(function() {
					setTop();
					$(window).on('resize', setTop);
					$(window).on('scroll', setTop);
				});
			};

			return {init: init};

		})();

		$fixed.init();

		var $locations = (function() {
			var $select = $('[data-office-select]'),
			$addresses = $('[data-office]'),

			init = function() {
				$addresses.hide();
				$addresses.first().show();
				$select.on('change', function() {
					$addresses.hide();
					var $selected = $(this).find('option:selected').val();
					$('[data-office="' + $selected + '"]').show();
				});
			};

			return {init: init};

		})();

		$locations.init();

		/*
		* Equal height elements
		*/
		var $equalHeights = (function() {
			var $parents = $('[data-equal-heights]'),
			resize = function() {
				$parents.each(function() {
					var $children = $(this).find('[data-equal-height]');
					var $max = 0;
					$children.css('min-height', $max + 'px');
					$children.each(function() {
						var $height = $(this).outerHeight();
						$max = $height > $max ? $height : $max;
					});
					$children.css('min-height', $max + 'px');
				});
			},
			initEvents = function() {
				$(window).on('resize', resize);
			},
			init = function() {
				resize();
				initEvents();
			};
			return {init: init};
		})();

		$equalHeights.init();
		
		$('[data-slick]').each(function() {
			var params = $(this).data('slick') || {};
			$(this).slick(params);
		})
		/*
		 * When clicking on certain elements we can add or remove
		 * body classes in order to show or hide elements
		 * accordingly
		 */
		var $addRemoveClasses = (function() {

			var init = function() {
				$(document).on('click', '[data-add-class]', function(e) {
					e.preventDefault();
					var $class = $(this).data('add-class');
					var $target = typeof $(this).data('add-to') !== 'undefined' ? $($(this).data('add-to')) : $('body');
					if( ! $target.hasClass($class) ) {
						$target.addClass($class);
					} else {
						$target.removeClass($class);
					}
				});
				$(document).on('click', '[data-remove-class]', function(e) {
					e.preventDefault();
					var $class = $(this).data('remove-class');
					var $target = typeof $(this).data('remove-from') !== 'undefined' ? $($(this).data('remove-from')) : $('body');
					if( $target.hasClass($class) ) {
						$target.removeClass($class);
					}
				});
			};

			return {init: init};

		})();

		$addRemoveClasses.init();

		/*
		* Basic tab functionality
		*/
		var $diTabs = (function() {

			var $buttons = $('[data-di-target]'),
			$container = $('[data-di-tabs]'),

			showTab = function($button) {
				var $container = $button.closest('[data-di-tabs]');
				$container.find('[data-di-tab]').hide();
				var $class = typeof $container.data('di-tabs-active-class') !== 'undefined' ?
					$container.data('di-tabs-active-class') :
					'di-tab--active';
				$container.find('[data-di-target]').removeClass($class);
				$button.addClass($class);
				var $target = $button.data('di-target');
				$container.find('[data-di-tab="' + $target + '"]').fadeIn();
			},

			initEvents = function() {
				$buttons.on('click', function(e) {
					e.preventDefault();
					showTab($(this));
					$(window).trigger('ditab_change');
				});
			},

			init = function() {
				initEvents();
				$container.each(function() {
					showTab($(this).find($buttons).first());
				});
			};

			return {init: init}; 
		})();

		$diTabs.init();

		// add active class to button if category matches - Filters
        $(function(){
            $(".blog-links a").each(function(){
          
                if($(this).attr("href").indexOf(window.location.pathname) != -1)   {
                    $(this).addClass("button--purple");
                    $(this).removeClass("button--white");
                   
                }
			});
        });

        // Recent case studies partial - When page loads make sure the "all" tab is highlighted
        $(function(){
        	var elementClicked;
            $(".links a").each(function(){
          		
                $(this).click(function(){
				   elementClicked = true;
				   $('[data-category-filter="all"]').removeClass('button--purple');
				});
				if( elementClicked != true ) {
				    $('[data-category-filter="all"]').addClass('button--purple');
				    
				} else {
					$('[data-category-filter="all"]').removeClass('button--purple');
				}

			});
        });

        $('.you-might-also-like__inner.blog-slider').slick({
            dots: false,
            infinite: false,
            autoplay: false,
            arrows: false,
            slidesToShow: 2,
            responsive: [
              {
                breakpoint: 991,
                settings: {
                    slidesToShow: 1,
                    dots: true,
                    infinite: true,
                    autoplay: true,
                    autoplaySpeed: 6000,
                    arrows: true,
                }
              },
            ]
        });

        $('.you-might-also-like__inner[data-rest-of-team-slider]').slick({
            dots: false,
            infinite: false,
            autoplay: false,
            arrows: true,
            slidesToShow: 2,
            responsive: [
              {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    dots: true,
                    infinite: true,
                    autoplay: true,
                    autoplaySpeed: 6000,
                    arrows: true,
                }
              },
            ]
        });

        $('.locations-we-cover__slider').slick({
        	infinite: false,
            dots: true,
            autoplay: false,
            arrows: false,
            slidesToShow: 3,
            responsive: [
              {
                breakpoint: 991,
                settings: {
                    infinite: false,
		            dots: true,
		            autoplay: false,
		            arrows: false,
		            slidesToShow: 2.5,
                }
              },
              {
                breakpoint: 767,
                settings: {
                    infinite: false,
		            dots: true,
		            autoplay: false,
		            arrows: false,
		            slidesToShow: 2,
                }
              }, 
              {
                breakpoint: 500,
                settings: {
                    infinite: false,
		            dots: true,
		            autoplay: false,
		            arrows: false,
		            slidesToShow: 1,
		            centerMode: false,
					centerPadding: '30px',
                }
              }, 
            ]
        }); 

        $('.recent-case-studies--slider').slick({
        	infinite: false,
            dots: true,
            autoplay: false,
            arrows: false,
            slidesToShow: 1.15,
     //        responsive: [
     //          {
     //            breakpoint: 991,
     //            settings: {
     //                infinite: false,
		   //          dots: true,
		   //          autoplay: false,
		   //          arrows: false,
		   //          slidesToShow: 1.5,
     //            }
     //          },
     //          {
     //            breakpoint: 767,
     //            settings: {
     //                infinite: false,
		   //          dots: true,
		   //          autoplay: false,
		   //          arrows: false,
		   //          slidesToShow: 1,
     //            }
     //          }, 
     //          {
     //            breakpoint: 500,
     //            settings: {
     //                infinite: false,
		   //          dots: true,
		   //          autoplay: false,
		   //          arrows: false,
		   //          slidesToShow: 1,
		   //          centerMode: false,
					// centerPadding: '30px',
     //            }
     //          }, 
     //        ]
        }); 

  //       function getSliderSettings(){
		//  	return {
		// 	    infinite: true,
		// 	    slidesToShow: 3,
		// 	    slidesToScroll: 1
		//  	}
		// }

        // Videos
        
        $(".play-youtube").modalVideo({channel:'youtube'});

        $('[data-play-vimeo]').modalVideo({channel:'vimeo'});

	},
	finalize() {
	// JavaScript to be fired on all pages, after page specific JS is fired
		// var $imageBoxes = (function() {

		// 	var $boxes = $('[data-image-box]'),

		// 	setPadding = function() {
		// 		var $windowWidth = $(window).width();
		// 		var $containerWidth = $('.container').width();
		// 		var $padding = ($windowWidth - $containerWidth) / 2;

		// 		$boxes.each(function() {
		// 			var $content = $(this).find('[data-image-box-content]');
		// 			$content.css('padding-left', $padding + 'px');
		// 		});
		// 	},

		// 	initEvents = function() {
		// 		$(window).on('resize', setPadding);
		// 	},

		// 	init = function() {
		// 		initEvents();
		// 		setPadding();
		// 	};

		// 	return {init: init};

		// })();

		// $imageBoxes.init();
	},
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js